export const formFields = () => {
  const $controller = $('[name="organization_type"]');

  $controller.on('change', function(e) {
    const dataController = e.target.getAttribute('data-controller');

    $(`[data-${dataController}]`).hide();
    $(`[data-${dataController}="${e.target.value}"]`).show();
  });
};
